import ApplicationRecord from './ApplicationRecord';
/**
 * Contact page form
 *
 *
 */
export default class ContactFormPage extends ApplicationRecord({
  /**
   * @type {Number}
   */
  ID: -1,
  /**
     * @type {String}
     */
  Path: '',
  /**
     * Absolute path.
     * @type {String}
     */
  URL: '',
  /**
     * @type {String}
     */
  Title: '',
  /**
     * @type {String}
     */
  Content: '',
  /**
     * @type {Object}
     */
  _embedded: {},
}) {}



// WEBPACK FOOTER //
// ./src/models/ContactFormPage.js